"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function camelToKebab(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.default = camelToKebab;
//# sourceMappingURL=camelToKebab.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/theme/utils/camelToKebab.js
// module id = 25
// module chunks = 0